import i18n from './i18n';
const { t } = i18n.global;
export const ELEMENT_TYPE_ZH1 = {
  text: '文本',
  image: '图片',
  shape: '形状',
  line: '线条',
  chart: '图表',
  table: '表格',
  video: '视频',
  audio: '音频',
  latex: '公式',
}
export const ELEMENT_TYPE_ZH = {
  text: t(`hotkey.element.text`),
  image: t(`hotkey.element.image`),
  shape: t(`hotkey.element.shape`),
  line: t(`hotkey.element.line`),
  chart: t(`hotkey.element.chart`),
  table: t(`hotkey.element.table`),
  video: t(`hotkey.element.video`),
  audio: t(`hotkey.element.audio`),
  latex: t(`hotkey.element.latex`),
}

export const MIN_SIZE = {
  text: 20,
  image: 20,
  shape: 15,
  chart: 200,
  table: 20,
  video: 250,
  audio: 20,
  latex: 20,
}